import React from 'react';
import { NamedLink } from '../../../../components';
import css from './SectionFAQ.css';

export const questions = [
    {
        heading: 'Wie funktioniert Flip & Win?',
        description: (
            <p>
                Zieh einmal pro Tag eine Karte und gewinne mit etwas Glück kostenlose Credits oder
                tolle Preise wie Rabatte, Gutscheine oder Produkte deiner Lieblingsmarken im
                Pferdesport.
            </p>
        ),
    },
    {
        heading: 'Wie oft kann ich spielen?',
        description: <p>Du kannst einmal pro Tag kostenlos eine Karte ziehen.</p>,
    },
    {
        heading: 'Wann kann ich das nächste Mal spielen?',
        description: (
            <p>
                Neue Karten werden dir nach Ablauf von 24 Stunden angezeigt - komm also später
                wieder und versuch dein Glück erneut!
            </p>
        ),
    },
    {
        heading: 'Was kann ich gewinnen?',
        description: (
            <p>
                Du kannst 5 bis 100 Credits, tolle Preise wie Rabatte, Gutscheine oder Produkte
                deiner Lieblingsmarken gewinnen oder leer ausgehen.
            </p>
        ),
    },
    {
        heading: 'Was passiert, wenn ich gewinne?',
        description: (
            <p>
                Wenn Du Credits gewinnst, klicke auf die Schatfläche „Einlösen“, damit sie
                automatisch deinem Konto gutgeschrieben werden. Handelt es sich um einen Preis, also
                einen Rabatt, Gutschein oder ein Produkt, klicke auf die Schaltfläche „Ansehen“, um
                weitere Details zu erhalten.
            </p>
        ),
    },
    {
        heading: 'Was passiert, wenn ich nichts gewinne?',
        description: <p>Keine Sorge: Du verlierst nichts - versuch es einfach morgen erneut.</p>,
    },
    {
        heading: 'Muss ich bezahlen, um mitzumachen?',
        description: (
            <p>
                Nein. Das Karten-Spiel „Flip & Win“ ist komplett kostenlos und unverbindlich. Du
                musst jedoch ein aktives Mitglied sein. Um ein kostenloses Konto bei HorseDeal zu
                erstellen, besuche die Seite <NamedLink name="SignupPage">Registrieren</NamedLink>.
            </p>
        ),
    },
    {
        heading: 'Warum sehe ich ein Schloss auf der Karte?',
        description: (
            <p>
                Wenn Du das Karten-Spiel „Flip & Win“ heute bereits gespielt hast, sind die Karten
                bis morgen gesperrt und dein Countdown wird angezeigt. Du kannst dann wieder eine
                neue Karte ziehen. Stelle zudem sicher, dass Du in deinem Konto angemeldet bist. Um
                ein kostenloses Konto bei HorseDeal zu erstellen, besuche die Seite{' '}
                <NamedLink name="SignupPage">Registrieren</NamedLink>.
            </p>
        ),
    },
    {
        heading: 'Wo sehe ich meine gewonnen Credits?',
        description: (
            <p>
                Einen Überblick über deine gesammelten oder erworbenen Credits erhältst Du auf der
                Seite <NamedLink name="BalancePage">Meine Bilanz</NamedLink>. Melde dich in deinem Konto
                an und klicke in der Navigation anschliessend auf „Meine Bilanz“. Gutschriften aus
                „Flip & Win“ werden mit dem Label „Bonus-Credits“ aufgeführt.
            </p>
        ),
    },
    {
        heading: 'Kann ich schummeln oder öfter spielen?',
        description: (
            <p>
                Unser System erkennt Mehrfachversuche - bitte spiele fair und freue dich auf deine
                tägliche Chance!
            </p>
        ),
    },
];
